import React, { useEffect, useState } from 'react'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { DataGrid } from '@mui/x-data-grid';
import BranchTools from './BranchTools';
import BranchModal from './BranchModel';
import { BranchDelete, BranchShowdata } from '../../../services/LoginPageService';
import DeleteConfirmationDailog from '../../../utils/confirmDeletion';
import { Tooltip } from '@mui/material';
import NotificationBar from '../../notification/ServiceNotificationBar';

const BranchList = () => {
  const [rows,setRow]=useState([]);
  const [isAddButton, setIsAddButton] = useState(true);
  const [editBranch, setEditBranch] = useState('');
  const [open, setOpen] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  const [isLoading, setGridLoading] = useState(true);
  const [deleteId,setDeleteId]=useState('');
  const [deleteDailogOpen,setDeleteDailogOpen]= useState(false);
  const [openNotification, setNotification] = useState({
    status: false,
    type: 'error',
    message: '',
  });
  
  const columns = [
    {
      field: 'location',
      headerClassName: 'super-app-theme--header',
      headerName: 'Location',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'branch',
      headerClassName: 'super-app-theme--header',
      headerName: 'Hostel Name',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'reportStartTime',
      headerClassName: 'super-app-theme--header',
      headerName: 'Report Start',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
      field: 'reportEndTime',
      headerClassName: 'super-app-theme--header',
      headerName: 'Report End',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
      field: 'smsSendTime',
      headerClassName: 'super-app-theme--header',
      headerName: 'SMS Sent At',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
      field: 'deviceId',
      headerClassName: 'super-app-theme--header',
      headerName: 'Device Id',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
      field: 'description',
      headerName: 'Description',
      headerClassName: 'super-app-theme--header',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      headerClassName: 'super-app-theme--header',
      width: 250,
      cellClassName: 'actions',
      disableClickEventBubbling: true,
      getActions: (params) => [
        <EditData selectedRow={params.row} />, 
        <DeleteData selectedRow={params.row} />,
        
      ],
    },
  ];

  useEffect(()=>{
    BranchShowdata(handleBranchShow,handeBranchException);
  },[refreshData]);
    
  const handleBranchShow=(dataObject)=>{
    setGridLoading(false);
    setRow(dataObject?.data || []);
  }
    
  const handeBranchException=(errorStatus, errorMessage)=>{
    console.log(errorMessage);
  }

  function EditData(props) {
    return (
      <Tooltip title="Edit">
        <EditIcon style={{cursor: 'pointer'}}
          onClick={(event) => {
            event.stopPropagation();
            setIsAddButton(false);
            setEditBranch(props.selectedRow);
            setOpen(true);
          }}
        />
      </Tooltip>
    );
  }

  function DeleteData(props) {
    return (
      <Tooltip title="Delete">
        <DeleteIcon style={{cursor: 'pointer'}}
          onClick={() => {
          setDeleteId(props.selectedRow.id);
          console.log(props.selectedRow.id);
          setDeleteDailogOpen(true);
          }}
        />
      </Tooltip>
    );
  }

  const DeleteFunction =()=>{
    BranchDelete(handleDeleteSuccess,handleDeleteException);
  }

  const handleDeleteSuccess = (dataObject) =>{
    console.log(dataObject);
      setNotification({
      status: true,
      type: 'success',
      message: dataObject.message,
    }); 
    setTimeout(()=>{
        setDeleteDailogOpen(false);
      }, 2000); 
    setRefreshData(oldValue => !oldValue);
  }

  const handleDeleteException = (errorObject, message) =>{
    console.log(message);
    setNotification({
      status: true,
      type: 'error',
      message:message,
    });
  }

  const handleClose = () => {
    setNotification({
      status: false,
      type: '',
      message: '',
    });
  };

  return (
    <div style={{ height: 520, width: '98%',overflow: "scroll" }}>
      <BranchTools
        setIsAddButton={setIsAddButton}
        editBranch={editBranch}
        setOpen={setOpen}
        setEditBranch={setEditBranch}   
      />
      <BranchModal
        isAddButton={isAddButton}
        editBranch={editBranch}
        setEditBranch={setEditBranch} 
        open={open}
        setOpen={setOpen}
        setRefreshData={setRefreshData}
        handleClose={handleClose}
        openNotification={openNotification}
        setNotification={setNotification}
      />

      <NotificationBar
        handleClose={handleClose}
        notificationContent={openNotification.message}
        openNotification={openNotification.status}
        type={openNotification.type}
      />

      <DeleteConfirmationDailog
        open={deleteDailogOpen}
        setOpen={setDeleteDailogOpen}
        deleteId={deleteId}
        deleteService={BranchDelete}
        handleSuccess={handleDeleteSuccess}
        handleException={handleDeleteException}
      />
      
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={8}
        loading={isLoading} 
        rowsPerPageOptions={[8]}
        disableSelectionOnClick
        sx={{
          height: '480px',
          width: '100%',
          '& .super-app-theme--header': {
            WebkitTextStrokeWidth:'0.6px',
            
          },
        }}
      />
    </div>
  )
}

export default BranchList
